import React from "react";

const SvgComponent = (props) => (
  <svg
    width={360}
    height={431}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={360}
      height={431}
    >
      <path fill="#D9D9D9" d="M0 0h360v431H0z" />
    </mask>
    <g mask="url(#a)">
      <path fill="#fff" d="M0 0h360v24H0z" />
      {/* <path
        d="M18.25 6.013V16h-1.648V7.968l-2.44.827v-1.36l3.89-1.422h.198Zm9.96 4.177v1.626c0 .78-.077 1.445-.232 1.996-.15.547-.37.992-.656 1.334a2.576 2.576 0 0 1-1.033.752c-.396.159-.84.239-1.333.239-.392 0-.756-.05-1.093-.15a2.672 2.672 0 0 1-.903-.472 2.82 2.82 0 0 1-.69-.828 4.63 4.63 0 0 1-.438-1.223 8.023 8.023 0 0 1-.15-1.648V10.19c0-.783.077-1.444.232-1.982.155-.542.376-.982.663-1.32.288-.341.63-.59 1.026-.744a3.69 3.69 0 0 1 1.34-.233c.396 0 .76.05 1.093.15.338.096.638.249.903.459.269.21.497.483.683.82.192.333.338.736.438 1.21.1.47.15 1.016.15 1.64Zm-1.647 1.859V9.943a7.07 7.07 0 0 0-.069-1.046 3.102 3.102 0 0 0-.205-.772 1.54 1.54 0 0 0-.328-.52 1.156 1.156 0 0 0-.45-.293 1.593 1.593 0 0 0-.568-.096c-.256 0-.483.05-.684.15-.2.096-.369.25-.506.465-.137.214-.241.497-.314.848a6.647 6.647 0 0 0-.103 1.264v2.106c0 .4.023.754.069 1.06.045.305.114.567.205.786.09.214.2.392.328.533.132.136.282.237.451.3.173.064.362.096.567.096.26 0 .49-.05.69-.15.201-.1.37-.26.507-.479.136-.223.239-.512.307-.868.069-.355.103-.781.103-1.278Zm3.247 3.13c0-.255.087-.469.26-.642.173-.178.408-.267.704-.267.3 0 .536.09.704.267.173.173.26.387.26.643 0 .255-.087.47-.26.642-.168.173-.403.26-.704.26-.296 0-.53-.087-.704-.26a.873.873 0 0 1-.26-.642Zm.007-5.824c0-.255.087-.469.26-.642.173-.178.408-.267.704-.267.3 0 .535.09.704.267.173.173.26.387.26.642 0 .256-.087.47-.26.643-.169.173-.403.26-.704.26-.296 0-.531-.087-.704-.26a.873.873 0 0 1-.26-.643Zm10.439 3.097v1.313h-7.178l-.055-.992 4.293-6.726h1.32l-1.429 2.447-2.468 3.958h5.517Zm-1.244-6.405V16h-1.648V6.047h1.648Zm8.846 4.143v1.626c0 .78-.078 1.445-.233 1.996-.15.547-.369.992-.656 1.334a2.576 2.576 0 0 1-1.032.752c-.397.159-.841.239-1.333.239a3.82 3.82 0 0 1-1.094-.15 2.67 2.67 0 0 1-1.593-1.3 4.634 4.634 0 0 1-.437-1.223 8.03 8.03 0 0 1-.15-1.648V10.19c0-.783.077-1.444.232-1.982.155-.542.376-.982.663-1.32.287-.341.629-.59 1.025-.744a3.691 3.691 0 0 1 1.34-.233c.397 0 .761.05 1.094.15.337.096.638.249.902.459.27.21.497.483.684.82.191.333.337.736.437 1.21.1.47.15 1.016.15 1.64Zm-1.648 1.859V9.943c0-.396-.023-.745-.068-1.046a3.098 3.098 0 0 0-.205-.772 1.54 1.54 0 0 0-.328-.52 1.155 1.155 0 0 0-.451-.293 1.594 1.594 0 0 0-.568-.096c-.255 0-.483.05-.683.15-.2.096-.37.25-.506.465-.137.214-.242.497-.315.848a6.646 6.646 0 0 0-.102 1.264v2.106c0 .4.023.754.068 1.06.046.305.114.567.205.786.091.214.2.392.328.533.133.136.283.237.451.3.174.064.363.096.568.096.26 0 .49-.05.69-.15.2-.1.37-.26.506-.479.137-.223.24-.512.308-.868.068-.355.102-.781.102-1.278Z"
        fill="#091D5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.941 6h-1.059c-.584 0-1.058.504-1.058 1.125v9.75c0 .621.474 1.125 1.058 1.125h1.059c.585 0 1.059-.504 1.059-1.125v-9.75c0-.621-.474-1.125-1.059-1.125Zm-6 2.625H290c.585 0 1.059.504 1.059 1.125v7.125c0 .621-.474 1.125-1.059 1.125h-1.059c-.585 0-1.059-.504-1.059-1.125V9.75c0-.621.474-1.125 1.059-1.125Zm-3.882 2.625H284c-.585 0-1.059.504-1.059 1.125v4.5c0 .621.474 1.125 1.059 1.125h1.059c.585 0 1.059-.504 1.059-1.125v-4.5c0-.621-.474-1.125-1.059-1.125Zm-4.941 2.25h-1.059c-.585 0-1.059.504-1.059 1.125v2.25c0 .621.474 1.125 1.059 1.125h1.059c.584 0 1.058-.504 1.058-1.125v-2.25c0-.621-.474-1.125-1.058-1.125ZM310 8.492c2.322 0 4.555.932 6.237 2.603a.313.313 0 0 0 .454-.004l1.211-1.277a.362.362 0 0 0-.003-.499c-4.416-4.42-11.382-4.42-15.798 0a.362.362 0 0 0-.003.5l1.211 1.276a.313.313 0 0 0 .454.004c1.683-1.671 3.916-2.603 6.237-2.603Zm0 4.154c1.276 0 2.506.495 3.451 1.39.128.126.33.123.454-.007l1.21-1.277a.36.36 0 0 0 .098-.252.36.36 0 0 0-.103-.25c-2.879-2.797-7.338-2.797-10.217 0a.36.36 0 0 0-.004.502l1.209 1.277c.125.13.326.133.454.006a5.02 5.02 0 0 1 3.448-1.39Zm2.424 2.795a.355.355 0 0 1-.099.252l-2.092 2.206A.321.321 0 0 1 310 18a.32.32 0 0 1-.232-.101l-2.093-2.206a.354.354 0 0 1 .01-.5 3.469 3.469 0 0 1 4.63 0 .348.348 0 0 1 .109.248Z"
        fill="#091D5C"
      />
      <path
        opacity={0.4}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M326.667 7h16.37c.92 0 1.666.746 1.666 1.667v6.666c0 .92-.746 1.667-1.666 1.667h-16.37A1.667 1.667 0 0 1 325 15.333V8.667c0-.92.746-1.667 1.667-1.667ZM324 8.667A2.667 2.667 0 0 1 326.667 6h16.37a2.667 2.667 0 0 1 2.666 2.667v6.666A2.667 2.667 0 0 1 343.037 18h-16.37A2.667 2.667 0 0 1 324 15.333V8.667ZM348 12c0 .925-.516 1.759-1.31 2.118V9.882c.794.36 1.31 1.194 1.31 2.118Z"
        fill="#091D5C"
      /> */}
      {/* <rect
        x={325.973}
        y={8.118}
        width={17.757}
        height={7.765}
        rx={1.333}
        fill="#091D5C"
      /> */}
      <path
        d="M-951.419 322.003c-112.461 67.224-201.911 21.913-232.581-9.146V-89H361v341.264c-92.01-45.73-173.158-49.16-285.614 57.735-89.965 85.516-202.763 97.749-247.916 93.176l-.332-.027c-37.757-3.053-104.219-8.427-156.851-61.709C-382.5 288-426.835 264.268-472.84 241.403c-46.005-22.865-136.737-32.011-229.386-24.008-92.649 8.002-108.623 20.578-249.193 104.608Z"
        fill="#f29a7c"
      />
      <path
        d="M121.106 101.794s5.715-4.728 4.376-8.118c-1.25-3.479-7.323-2.409-9.645-1.784-2.322.535-2.679 4.728-.893 7.404 1.965 2.587 6.162 2.498 6.162 2.498ZM312.035 264.242c-.089-.446-.267-.803-.357-1.159-.714-2.409-1.518-4.55-2.143-6.156-2.233-33.185-7.591-59.056-16.521-79.127-2.59-5.888-4.287-9.546-5.805-11.508-.893-1.16-6.697-1.517-10.448.803-3.93 2.408-6.519 7.582-5.09 9.902 1.786 2.944 2.679 4.906 4.911 10.169 9.288 21.946 13.574 49.511 15.539 69.583-1.25 3.122-2.59 7.226-3.661 9.456-.626 1.249-2.501 5.531-1.429 6.334.982.713 4.108-1.963 5.447-3.479 1.161 9.099 6.876 21.856 5.894 2.587.268 1.962 1.875 12.667 4.287 11.329 2.143-1.249 1.339-9.01.893-12.132h.089c.714 3.211 2.679 10.883 4.287 9.01 2.054-2.32 1.428-10.794 1.428-10.794s1.072 10.883 3.84 8.474c1.697-1.605-.535-10.259-1.161-13.292Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M306.32 208.041c-9.823-39.251-19.915-45.228-19.915-45.228s-11.43-9.457-34.292-13.203c-.982-.179-1.965-.357-3.036-.446-.893-.09-1.786-.268-2.679-.357-3.483-.357-7.055-.446-10.627-.179-2.144.179-4.198.357-6.162.714-15.539 2.498-26.345 15.433-30.988 22.035-7.145 8.296-14.021 9.277-20.094 10.794-15.36 3.746-26.344-10.884-32.952-15.701l-6.341 9.099-6.34 9.1c.357.267 8.037 9.812 17.771 16.592 15.449 10.884 35.632 8.297 47.956 6.066-.983 12.757-1.429 27.298-2.501 43.177 0 0 26.791-11.151 84.749 3.479 0 0 1.339-22.034.446-45.228 4.554 16.146 6.698 36.843 9.913 38.003 4.286 1.516 17.503 1.248 17.503 1.248s7.412-.713-2.411-39.965Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M162.989 186.988s-7.234-10.794-14.557-14.095c-7.322-3.301-12.056-.535-12.056-.535l-7.858-3.122s-1.161 29.884 19.379 24.621c1.607-.446 15.092-6.869 15.092-6.869Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m129.679 153.535 7.501 43.355c.536 2.855 3.215 4.728 6.073 4.104l20.182-4.104c2.679-.535 4.465-3.122 4.019-5.888l-7.412-42.73c-.447-2.766-3.126-4.639-5.894-4.193l-20.272 3.479c-2.858.535-4.733 3.211-4.197 5.977Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M134.144 153.624a1.338 1.338 0 1 0 0-2.676 1.339 1.339 0 1 0 0 2.676Z"
        fill="#100B47"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M125.035 170.217s-2.679-5.799 2.679-8.207c6.787-3.033 18.218-.357 13.931 1.695-3.84 1.784-9.823 2.944-9.823 2.944s15.271-2.855 14.824.535c-.446 3.39-13.663 5.62-13.663 5.62s15.181-1.427 13.663 1.695c-1.518 3.033-13.484 5.174-13.484 5.174s14.735-2.141 12.859 1.338c-1.786 3.479-9.645 3.033-13.038 3.658-3.215.535-4.554-1.339-4.822-4.461 0 0-2.144-2.944-1.786-4.996.089-.802-.715-1.427-.893-1.962-.358-1.071-.447-3.033-.447-3.033Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M280.868 253.894c-.089 3.122-19.021 4.371-42.508 3.658-23.486-.714-42.24-4.015-42.151-7.137.09-3.122 18.933-4.996 42.419-4.282 23.398.803 42.33 4.639 42.24 7.761Z"
        fill="#007EA2"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m244.522 144.792-2.321-7.493-.715-2.141-3.929-12.757-.536 12.668-.268 7.582-.089 2.409c-.09 1.606-1.072 1.963-2.322 3.39-.536.535-3.662 4.104-.089 5.62 4.465 1.963 12.77-.981 15.985-4.906 0 .089-5.001-1.963-5.716-4.372Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M227.376 117.584s-.803 3.122 0 6.958c.804 3.836 4.733-5.62 4.733-5.62l-4.733-1.338Z"
        fill="#30262A"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M250.327 126.416a2.709 2.709 0 0 0-.714-.714c-.268-6.245-4.198-11.419-9.556-12.132-6.251-.803-12.056 4.549-13.038 12.043-.982 7.493 3.215 14.184 9.466 15.076 5.894.803 11.52-4.104 12.86-11.062.089 0 .089-.089.178-.089 1.072-.714 1.429-2.141.804-3.122Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M237.557 126.594c-.09 0-.09-.089-.09-.178 0-.09.09-.268.179-.268s1.786-.357 2.679 1.517c.089.089 0 .267-.089.267-.09.089-.268 0-.268-.089-.804-.981-2.144-1.249-2.233-1.249h-.178ZM237.64 130.312c.381.104.805-.236.948-.758.143-.523-.05-1.031-.431-1.135-.38-.104-.804.236-.947.759-.143.523.05 1.031.43 1.134ZM229.073 125.88c-.09 0-.09-.089-.09-.089 0-.089 0-.267.09-.267.089 0 1.25-.982 2.322.267a.272.272 0 0 1 0 .357c-.09.089-.179.089-.268 0-.893-.535-1.876-.268-1.965-.268h-.089ZM230.545 129.363c.391-.049.654-.524.587-1.062-.068-.538-.44-.934-.831-.885-.392.049-.655.524-.587 1.062.067.538.439.934.831.885Z"
        fill="#080435"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M248.184 111.429s5.715-4.728 4.375-8.118c-1.25-3.48-7.322-2.409-9.644-1.785-2.322.536-2.679 4.729-.893 7.405 1.964 2.587 6.162 2.498 6.162 2.498ZM239.432 405.013c-2.768-.178-5.269 1.249-6.608 3.657-.626 1.16-1.519 2.141-2.858 2.677-4.108 1.695-15.985 3.211-11.52 7.136 2.59 2.231 14.556.803 17.95.803 3.393 0 6.608 1.517 9.109-.803 1.518-1.338 1.339-5.62.982-9.277-.357-2.587-2.679-4.55-5.269-4.193-.357.089-.804.089-1.161.089-.268-.089-.446-.089-.625-.089ZM281.315 403.586s-.178 6.066-4.286 7.761c-4.108 1.695-15.985 3.211-11.52 7.136 2.59 2.231 14.556.803 17.95.803 3.393 0 6.608 1.517 9.109-.803 2.768-2.497 0-14.897 0-14.897s-2.947 1.516-5.537 1.427c-3.751-.089-5.716-1.427-5.716-1.427Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m300.694 400.285-25.005-137.559c-.357-1.606-1.25-8.832-2.858-9.278-1.786-.535-4.733-.981-8.305-1.338 0 0-15.539-1.963-33.042-1.963-9.913 0-18.486.803-22.683 1.249-1.875.179-3.304 1.606-3.572 3.479-.447 3.658-.536 11.508 1.697 27.655 3.215 23.729 15.538 110.351 17.592 121.858.715 4.104 1.608 6.691 7.591 7.583l7.948-.178c6.519.981 8.93-5.977 9.02-10.438l-3.483-90.189 28.398 91.081c1.875 6.156 7.412 10.349 13.753 10.438l2.768.089c6.341 0 11.342-5.977 10.181-12.489Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m248.72 321.246-9.824-29.795c-2.232-6.691-6.787-12.311-12.77-15.79l.357-.624c6.162 3.568 10.895 9.277 13.128 16.146l9.823 29.796-.714.267Z"
        fill="#020202"
      />
      <path
        d="M259.972 152.286s4.733-4.371-.983-5.977c-2.232-.624-5.626-6.155-8.752-5.709-3.125.446-5 18.198-17.681 23.64 0 0-3.126 2.676 1.964 2.587 5.09-.089 25.452-14.541 25.452-14.541Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M232.645 164.24s-6.34-6.245-5.179-12.043c1.071-5.799-2.144-10.794-3.662-8.118-1.607 2.587-3.393.981-3.75 4.282-.358 3.301 4.554 19.447 8.93 19.447 4.376 0 3.661-3.568 3.661-3.568ZM234.074 165.489s4.108 1.873 2.59 6.155c-1.519 4.371.625 6.066.625 6.066s-4.912.268-5.537-4.46c-.715-4.55 2.322-7.761 2.322-7.761Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M231.752 165.489s-5.179 1.784-5.447 5.174c-.268 3.39 2.768 4.193 3.84 2.141 1.071-2.052 3.215-5.977 3.215-5.977l-1.608-1.338Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M252.47 111.429c-7.68-5.353-19.736-1.339-23.576 1.784-3.751 3.122-1.697 10.259-1.697 10.259s1.787-3.836 3.215-4.818c1.519-.981 5.805-.356 9.556 0 3.75.357 3.036 5.175 3.036 5.175s.715 6.869-.625 8.207c-.447.446-1.875.803-3.661.981-1.608-.535-3.751.178-6.073-.178-2.322-.446-5.18-.625-5.18-.625s-2.589 1.427-.714 7.137c1.786 5.62.268 2.408-1.875 7.672-2.144 5.263 2.411 4.192 1.339 8.385s2.947 6.691 8.127 3.925c5.179-2.765 1.696-2.854 4.643-6.601s.715-6.066 4.108-8.742c3.394-2.677 3.394-7.405 3.394-7.405.357-.892-.715-6.066-.715-6.066s-.357-2.765 1.161-4.46c3.93 3.568.983 7.761.983 7.761 5.358-.625 9.198-8.743 9.198-8.743s3.036-8.296-4.644-13.648Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M229.698 134.623s3.572.981 7.412.624c0 0-.535 3.569-4.465 2.855-2.322-.446-2.947-3.479-2.947-3.479ZM309.624 251.396s-11.967 1.249-18.128 0c0 0-.804 3.212.446 4.639 0 0 14.288 1.071 17.593 0 .089-.089 2.5-2.408.089-4.639Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M301.944 258.622a4.38 4.38 0 0 0 4.376-4.371v-.624a4.381 4.381 0 0 0-4.376-4.372 4.381 4.381 0 0 0-4.376 4.372v.624a4.38 4.38 0 0 0 4.376 4.371Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M230.055 192.43a1.517 1.517 0 1 0 .002-3.034 1.517 1.517 0 0 0-.002 3.034ZM230.055 210.717a1.517 1.517 0 1 0-1.518-1.516c0 .837.68 1.516 1.518 1.516ZM230.055 232.484a1.517 1.517 0 1 0-1.518-1.516c0 .837.68 1.516 1.518 1.516Z"
        fill="#30262A"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m281.226 209.825.714-.178c-2.857-12.311-7.858-23.73-7.948-23.819l-.714.268c.089.178 5.09 11.508 7.948 23.729ZM198.978 207.774c.804-13.649 7.591-31.223 7.68-31.402l-.714-.267c-.09.178-6.877 17.841-7.77 31.579l.804.09Z"
        fill="#30262A"
      />
      <path
        opacity={0.95}
        d="M171.294 307.33H60.201c-13.217 0-24.022-10.705-24.022-23.997V144.792c0-13.202 10.716-23.997 24.022-23.997h111.004c13.217 0 24.022 10.705 24.022 23.997v138.541c.09 13.292-10.716 23.997-23.933 23.997Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M133.876 252.288H60.469v4.55h73.407v-4.55ZM119.856 273.966H60.469v4.55h59.387v-4.55ZM95.297 263.083H60.47v4.549h34.828v-4.549ZM153.076 139.44v2.319h13.485v12.579h2.322V139.44h-15.807Zm-91.357 14.898h2.322v-12.579h13.485v-2.319H61.719v14.898Zm104.753 65.122v12.578h-13.485v2.32h15.717V219.46h-2.232Zm-102.52 0H61.63v14.898h15.717v-2.32H63.952V219.46ZM175.223 265.402c0-7.404-6.072-13.47-13.485-13.47-7.412 0-13.484 6.066-13.484 13.47 0 7.404 6.072 13.47 13.484 13.47 7.502-.089 13.485-6.066 13.485-13.47Zm-2.59 0a10.78 10.78 0 0 1-10.805 10.794 10.78 10.78 0 0 1-10.806-10.794 10.78 10.78 0 0 1 10.806-10.794c5.983-.089 10.805 4.817 10.805 10.794Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m160.935 270.665-6.073-6.155 1.786-1.784 4.287 4.282 5.983-5.977 1.875 1.784-7.858 7.85ZM163.793 210.004H148.7c-.982-7.226-2.232-15.433-2.232-15.433s-.625 6.78-1.34 15.433H84.76c-.536-7.761-1.25-13.649-1.43-13.738-.357-.179-2.5 6.69-4.286 13.738H62.702c4.197-18.11 12.056-47.102 16.61-48.886 6.43-2.498 32.774-10.616 32.774-10.616h15.003s26.702 7.583 29.202 15.879c1.875 6.691 6.251 28.368 7.502 43.623Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M132.09 126.059c2.143-21.945-11.877-24.086-11.877-24.086-17.146-1.963-16.789 17.841-16.789 17.841.446 12.311 3.126 18.912 5.983 22.391-.268 4.193-1.339 9.724-1.339 9.724 7.59 6.958 20.004.714 19.2-1.249-.625-1.338-.625-6.066-.536-8.831 2.411-2.944 4.554-7.762 5.358-15.79Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M132.269 119.903s1.518-1.605 2.143 0c.536 1.695-2.411 9.1-2.233 9.367 0 0-.267.625-.625.268-.357-.357.715-9.635.715-9.635ZM103.603 119.547s-1.519-1.695-2.144 0c-.625 1.605 2.233 9.099 1.965 9.456 0 0 .268.624.625.267.447-.267-.446-9.723-.446-9.723Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M127.268 150.68s3.125.714-10.091 13.381c0 0-9.377-10.348-9.109-12.132.357-1.784 19.2-1.249 19.2-1.249Z"
        fill="#EEA987"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="m117.176 163.972 3.572 6.245 10.717-18.199-4.644-3.211-9.645 15.165ZM117.176 163.972l-8.751-13.916-5.001 3.211 8.93 16.95 4.822-6.245Z"
        fill="#F15A25"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M114.408 202.599c.089 2.052.179 4.55.179 7.405h-.536c0-2.855-.09-5.353-.179-7.405-.804-15.433 2.947-34.256 2.947-38.716l.447.089c.089 4.461-3.662 23.284-2.858 38.627Z"
        fill="#B84343"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M110.747 142.651s3.304 3.48 8.037 2.588c4.733-.982 6.787-3.123 6.787-3.123.982-2.498-2.858 4.728-7.323 5.085-5.447.446-7.501-4.55-7.501-4.55Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M114.14 123.204c.09 0 .179-.089.179-.178 0-.179-.089-.357-.268-.357-.089 0-2.322-.714-3.84 1.606-.089.178-.089.356.089.446.179.089.268 0 .447-.09 1.25-1.159 3.036-1.338 3.125-1.338.09-.089.179-.089.268-.089ZM113.025 125.504c-.537.077-.888.732-.784 1.463.104.732.624 1.263 1.161 1.187.538-.077.888-.732.784-1.463-.104-.732-.624-1.263-1.161-1.187ZM125.571 123.739c.089 0 .178-.089.178-.089.09-.178 0-.357-.089-.446-.089-.089-1.518-1.606-3.215 0-.089.089-.178.268-.089.446.089.179.178.179.357.089 1.25-.624 2.59 0 2.679 0h.179ZM123.661 125.443c-.525-.134-1.1.338-1.282 1.054-.183.717.095 1.406.621 1.539.526.134 1.1-.338 1.283-1.054.182-.716-.096-1.405-.622-1.539Z"
        fill="#080435"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M131.733 123.204s2.858-14.808 1.518-19.447c-1.34-4.55-7.948-3.212-7.948-3.212-21.343-6.244-23.308 4.282-23.933 6.066-.625 1.785 1.875 18.645 1.875 18.645s.268 1.873.715 4.282c-.358 1.873-.715 6.423 1.875 9.991 3.394 4.728-.357 6.958 2.054 12.935 2.411 6.067 0 8.475 3.661 10.349 7.055 3.746 11.878 3.746 12.146-2.141.267-5.888 5.715-2.766 4.911-10.438-.803-7.761-4.108-4.103.447-10.794 3.75-5.709 2.411-8.564 1.875-9.367.089-.357.089-.624.089-.624l.715-6.245Zm-26.345-2.944c.983-.357.536-4.639.536-4.639 10.359-4.906 22.147-1.605 22.415-.981.268.625.804 3.479 1.072 4.371.357.892.268 6.78.268 6.78l-.715 1.249v2.498c-1.428-.268-1.964 4.014-3.84 3.836-3.214-.357-11.162-.089-13.484 0-1.518.089-1.876-5.799-4.823-5.263-1.071-.714-1.964-1.071-1.964-1.071s-.447-6.423.535-6.78Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        d="M122.892 135.426s-4.555.802-9.466-.09c0 0 .268 4.639 5.358 4.104 2.947-.268 4.108-4.014 4.108-4.014Z"
        fill="#fff"
        stroke="#000"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default SvgComponent;
